import { useQuery } from '@tanstack/react-query';
import * as chatApi from '../../api/chat';
import type { ChatAttachment } from '../../types/chat';
import { chatKeys } from './chatKeys';

export type AttachmentMap = Map<string, ChatAttachment>;

export function useChatRoomAttachments(
  roomId: string | null | undefined
): { map: AttachmentMap; isLoading: boolean } {
  const query = useQuery<ChatAttachment[]>({
    queryKey: roomId ? chatKeys.attachments(roomId) : ['chat', 'attachments', 'none'],
    queryFn: () => chatApi.listAttachments(roomId!, 1, 100),
    enabled: !!roomId,
    staleTime: 5 * 60 * 1000,
  });

  const map: AttachmentMap = new Map();
  for (const att of query.data ?? []) {
    map.set(att.id, att);
  }
  return { map, isLoading: query.isLoading };
}
